import { inject } from '@angular/core';

import { translateObject } from '@jsverse/transloco';

import { firstValueFrom } from 'rxjs';

import { SimpleDialogButtonColor } from '../../../components/simple-dialog.component';
import { DialogService } from '../../../services/dialog.service';
import { FieldViewComponent } from './field-view.component';

interface Translations {
  title: string;
  content: string;
  cancel: string;
  discard: string;
  apply: string;
  'invalid-field': string;
}

export const hasFieldViewUnsavedChangesGuard = async (
  component: FieldViewComponent
): Promise<boolean> => {
  if (!component?.isUnsaved) {
    return true;
  }

  let isDiscard = false;

  const dialogService = inject(DialogService);
  const translations = translateObject<Translations>('field-view.guard') as Translations;

  const dialogResult: boolean | undefined = await firstValueFrom(
    dialogService
      .showSimpleDialog({
        title: translations.title,
        content: translations.content,
        confirmTitle: translations.apply,
        confirmColor: SimpleDialogButtonColor.green,
        cancelTitle: translations.cancel,
        buttons: [
          {
            title: translations.discard,
            color: SimpleDialogButtonColor.orange,
            handler: (dialogRef) => {
              isDiscard = true;

              dialogRef.close();
            },
          },
        ],
        confirmButtonDisabled:
          component.fieldForm.invalid || (component.bucketForm && !component.bucketForm.valid),
        confirmButtonDisabledTooltip: translations['invalid-field'],
      })
      .afterClosed()
  );

  if (dialogResult) {
    return await component.onSave();
  }

  if (isDiscard) {
    component.onRevert();

    return true;
  }

  return false;
};
